export default __webpack_public_path__ + "static/media/marauders-map-v3-02-01.9181130e.jpg";